<template>
  <!-- eslint-disable -->
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <base-material-card
      icon="mdi-clipboard-text"
      title="QR Request"
      class="px-5 py-3"
    >
    
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">
              Account Number
            </th>            
            <th class="primary--text">
              Insta Buy Transaction Amount
            </th>
            <th class="primary--text">
              Insta Buy Requested Amount
            </th>
            <th class="primary--text">
              Vat/Pan Bill
            </th>
            <th class="primary--text">
              Pos Sales Slip
            </th>
            <th class="primary--text">
              Others
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(row, index) in rows"
            :key="row.id"
          >
            <td>
              {{ row.accountNumber }}
            </td>
            
            <td>{{ row.trasactionAmt }}</td>
            <td>{{ row.requestedAmt }}</td>
            <td>{{ row.installmentTenure }}</td>
            <td><img :src="row.panCopy" style="width: 50px" alt=""></td>
            <td><img :src="row.pos_slip" style="width: 50px" alt=""></td>
            <td><img :src="row.others_doc" style="width: 50px" alt=""></td>
          </tr>
        </tbody>
      </v-simple-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import Promise from '../../../../lib/mixins/ExtendedPromises'
  import Enquiry from '../../../../repositories/enquiry'

  export default {
    name: 'LoanEnquiryList',
    mixins: [Promise],
    data () {
      return {
        title: 'Vehicle',
        rows: [],
      }
    },
    async created () {
      this.rows = await Enquiry.get()
    },
  }

    </script>
